export const MERCHANDISE_DISPATCH_STATUS = {
  PENDING: 1,
  DISPATCHED: 2,
  DELIVERED: 3,
} as const;
